import React from "react";
import * as FaIcons from "react-icons/fa";

const Logo = ({ size }) => {
  return (
    <div className="dash-logo">
      <FaIcons.FaFolderOpen
        className="folder-icon"
        style={{ fontSize: `${size * 2.25}rem` }}
      />
      <h1 style={{ fontSize: `${size * 1.15}rem` }}>
        Enrollment <br />{" "}
        <span style={{ marginLeft: `${size * 0.25}rem` }}>Dashboard</span>
      </h1>
    </div>
  );
};

export default Logo;
